<style scoped lang="scss">
.report-card {
	cursor: pointer;
	transition: background-color 0.2s;
}

.report-card:hover {
	background-color: $secondary;
}

.report-card.active {
	background-color: $primary;
	color: white;
}

/* A long email must not push the row wider than the list's column. */
.contact-fact {
	min-width: 0;
	max-width: 100%;
}
</style>

<template>
	<div class="list-group-item p-3 report-card" :class="{ active: isSelected }">
		<div class="fw-semibold text-truncate">{{ contact.name }}</div>
		<!-- The row's reachable details: the first address of each kind, with a
		     count of the rest, so a row reads as a person rather than a name. -->
		<div
			v-if="firstEmail || firstPhone"
			class="d-flex flex-wrap gap-3 mt-1 small opacity-75"
		>
			<span v-if="firstEmail" class="contact-fact text-truncate">
				<i class="bi bi-envelope me-1" />{{ firstEmail }}
				<span v-if="extraEmails > 0">+{{ extraEmails }}</span>
			</span>
			<span v-if="firstPhone">
				<i class="bi bi-phone me-1" />{{ formatPhoneUS(firstPhone.e164) }}
				<span v-if="extraPhones > 0">+{{ extraPhones }}</span>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { formatPhoneUS } from "@/format";
import { Contact, Phone } from "@/type/api";

interface Props {
	contact: Contact;
	isSelected: boolean;
}
const props = defineProps<Props>();

const firstEmail = computed((): string | undefined => props.contact.emails[0]);
const extraEmails = computed((): number =>
	Math.max(0, props.contact.emails.length - 1),
);
const firstPhone = computed((): Phone | undefined => props.contact.phones[0]);
const extraPhones = computed((): number =>
	Math.max(0, props.contact.phones.length - 1),
);
</script>
